import Button from "../button/button";
import "./sticky-cta.css";

export default function StickyCta({training} :any) {
  return (
    <div className="ae-sticky-cta ae-card -dark-theme -shadow -animation -fade-in">
      <img className="ae-sticky-cta-image" src={training.image} alt=""/>
      <h2 className="ae-sticky-cta-title">Want to learn more about these courses?</h2>
      <p className="ae-sticky-cta-paragraph">Get in touch to discuss your requirements and find out how we can help.</p>
      <Button 
        buttonText ="Get in touch"
        buttonLink ="/get-in-touch"
        theme="light-theme"
      />
      <a className="ae-link" href="/training">← Back to all courses</a>
    </div>
  );
}
